import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary:    { main: '#9b4886', dark: '#7a3668', light: '#c08497' },
    secondary:  { main: '#7c3aed', light: '#a78bfa' },
    background: { default: '#06060f', paper: '#0e0e1c' },
    text:       { primary: '#e2e8f0', secondary: '#94a3b8' },
  },
  typography: {
    fontFamily: "'Inter', sans-serif",
    h1: { fontFamily: "'Poppins', sans-serif", fontWeight: 800 },
    h2: { fontFamily: "'Poppins', sans-serif", fontWeight: 800 },
    h3: { fontFamily: "'Poppins', sans-serif", fontWeight: 700 },
    h4: { fontFamily: "'Poppins', sans-serif", fontWeight: 700 },
    h5: { fontFamily: "'Poppins', sans-serif", fontWeight: 600 },
    h6: { fontFamily: "'Poppins', sans-serif", fontWeight: 600 },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: { overflowX: 'hidden', scrollBehavior: 'smooth' },
        body: {
          margin: 0,
          padding: 0,
          backgroundColor: '#06060f',
          '&::selection': { background: 'rgba(155,72,134,0.35)', color: '#fff' },
          '&::-webkit-scrollbar':        { width: '5px' },
          '&::-webkit-scrollbar-track':  { background: '#06060f' },
          '&::-webkit-scrollbar-thumb':  {
            background: 'linear-gradient(180deg, #9b4886, #c08497)',
            borderRadius: '3px',
          },
        },
        /* Orbit keyframes — used in Home.js hero */
        '@keyframes icon-orbit': {
          from: { transform: 'rotate(0deg)   translateX(140px) rotate(0deg)' },
          to:   { transform: 'rotate(360deg) translateX(140px) rotate(-360deg)' },
        },
        '@keyframes ring-rotate': {
          from: { transform: 'rotate(0deg)' },
          to:   { transform: 'rotate(360deg)' },
        },
        '@keyframes pulse-glow': {
          '0%,100%': { boxShadow: '0 0 20px rgba(155,72,134,0.3), 0 0 0 3px rgba(155,72,134,0.35)' },
          '50%':     { boxShadow: '0 0 45px rgba(155,72,134,0.6), 0 0 0 5px rgba(155,72,134,0.15)' },
        },
        '@keyframes float': {
          '0%,100%': { transform: 'translateY(0px)' },
          '50%':     { transform: 'translateY(-10px)' },
        },
        '@keyframes gradient-x': {
          '0%,100%': { backgroundPosition: '0% 50%' },
          '50%':     { backgroundPosition: '100% 50%' },
        },
        '@keyframes shimmer': {
          '0%':   { backgroundPosition: '-200% 0' },
          '100%': { backgroundPosition:  '200% 0' },
        },
        '@keyframes scroll-dot': {
          '0%':   { opacity: 1, transform: 'translateY(0)' },
          '100%': { opacity: 0, transform: 'translateY(16px)' },
        },
        '@keyframes otw-pulse': {
          '0%,100%': { opacity: 1,   transform: 'scale(1)' },
          '50%':     { opacity: 0.4, transform: 'scale(0.8)' },
        },
      },
    },
    MuiPaper:  { styleOverrides: { root: { backgroundImage: 'none' } } },
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 8, textTransform: 'none', fontFamily: "'Poppins', sans-serif", fontWeight: 600 },
      },
    },
    MuiChip: {
      styleOverrides: { root: { fontFamily: "'Poppins', sans-serif" } },
    },
  },
});

export default theme;
